/** Доля диаметра аватара, которую занимает кегль инициалов-фолбэка. */
export const AVATAR_INITIALS_RATIO = 0.36
